module.exports = __webpack_public_path__ + "static/ampedstudio.fb13013c.png";


//////////////////
// WEBPACK FOOTER
// ./src/sponsors/ampedstudio.png
// module id = 604
// module chunks = 192551386620669